import { useState } from 'react';
import { api, ApiError } from '../api.js';
import { useAuth } from '../auth.js';
import { t } from '../i18n.js';

export function LoginScreen() {
  const { refresh } = useAuth();
  const [pw, setPw] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try { await api.login(pw); await refresh(); }
    catch (e) { setErr(e instanceof ApiError && e.status === 401 ? t('login.wrong_password') : t('login.failed')); }
    finally { setBusy(false); }
  };

  return (
    <div className="auth-shell">
      <div className="card">
        <h2 style={{ margin: '0 0 12px' }}>charzapp</h2>
        <form onSubmit={submit}>
          <div className="field">
            <label className="label">{t('login.password')}</label>
            <input type="password" autoFocus value={pw} onChange={(e) => setPw(e.target.value)} />
          </div>
          {err && <div style={{ color: 'var(--danger)', marginBottom: 8 }}>{err}</div>}
          <button type="submit" disabled={busy || !pw} className="btn btn-primary" style={{ width: '100%' }}>
            {busy ? t('login.signing_in') : t('login.sign_in')}
          </button>
        </form>
      </div>
    </div>
  );
}
